import React from 'react';
import { downloadTemplate as downloadTemplateApi } from '../api/insuranceApi';
import { downloadBlob } from '../utils/fileUtils';
import { MESSAGES } from '../constants/messages';
import '../styles/Header.css';

interface HeaderProps {
  onShowInstructions: () => void;
  onStartFromScratch?: () => void;
  showStartFromScratch?: boolean;
  hideDownloadTemplate?: boolean;
  onGoHome?: () => void;
}

const Header: React.FC<HeaderProps> = ({ onShowInstructions, onStartFromScratch, showStartFromScratch, hideDownloadTemplate, onGoHome }) => {
  const handleDownloadTemplate = async () => {
    try {
      const blob = await downloadTemplateApi();
      downloadBlob(blob, 'insurance_template.xlsx');
    } catch (error) {
      console.error('Error downloading template:', error);
      alert(MESSAGES.ERROR_DOWNLOAD_TEMPLATE);
    }
  };
  return (
    <header className="header">
      <div className="header-content">
        <div 
          className="logo-section" 
          onClick={onGoHome}
          style={{ cursor: onGoHome ? 'pointer' : 'default' }}
          title={onGoHome ? "Αρχική Σελίδα" : undefined}
        >
          <div className="logo">
            <img src="/icon.png" alt="Insurance Checker" className="logo-icon" />
          </div>
          <div className="title-section">
            <h1 className="title">Insurance Checker</h1>
            <p className="subtitle">Σύστημα Επαλήθευσης Ασφάλισης Οχημάτων</p>
          </div>
        </div>
        <div className="header-actions">
          {showStartFromScratch && onStartFromScratch && (
            <button className="help-btn start-from-scratch-btn" onClick={onStartFromScratch} title="Νέα Αρχή">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6h14z"/>
              </svg>
              <span>Νέα Αρχή</span>
            </button>
          )}
          {!hideDownloadTemplate && (
          <button className="help-btn" onClick={handleDownloadTemplate} title="Λήψη Προτύπου Excel">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="7 10 12 15 17 10"/>
              <line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
            <span>Κατεβάστε το Πρότυπο</span>
          </button>
          )}
          <button className="help-btn" onClick={onShowInstructions} title="Οδηγίες Χρήσης">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
            <span>Οδηγίες</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
